export class AgmGlobals {
   delayedJsonProperties: DelayedJsonProperty[] = []
}

export class DelayedJsonProperty {
   className: string;
   target: any;
   classPropertyName: string;
   jsonPropertyName: string;
   conversionOption: any
}